/**
 * Generic `{{key}}` replacement over a flat string map.
 * Unknown placeholders are left unchanged.
 */
export function interpolatePlaceholders(
  template: string,
  placeholders: Record<string, string>
): string {
  return Object.entries(placeholders).reduce(
    (result, [key, value]) => result.split(`{{${key}}}`).join(value),
    template
  );
}
